const map = {
	"./0.png": 20132,
	"./1.png": 60077,
	"./2.png": 78454,
	"./3.png": 74783,
	"./4.png": 23456,
	"./5.png": 78281,
	"./6.png": 87570,
	"./7.png": 85435,
	"./8.png": 47628,
	"./9.png": 16725,
	"./Analyze.png": 8968,
	"./Annotate.png": 36854,
	"./Annotation.png": 97801,
	"./Barcode.png": 73540,
	"./BestFit.png": 41563,
	"./CaptureProfiles.png": 89920,
	"./Closed.png": 82138,
	"./Config.png": 55308,
	"./Containers.png": 42234,
	"./ConvertoScreen.png": 74178,
	"./Copy.png": 20673,
	"./Crystal.png": 33706,
	"./CrystalContainer.png": 15465,
	"./CrystalTrackSummary.png": 76521,
	"./Cut.png": 76364,
	"./DisabledImaging.png": 77462,
	"./Dispense.png": 17811,
	"./Dispensing.png": 42346,
	"./DisplayAndUsage.png": 73006,
	"./Expanded.png": 2113,
	"./Experiment-Plate.png": 69164,
	"./Experiment.png": 46767,
	"./Experiment1.png": 82486,
	"./ExperimentMenuIcon.png": 67293,
	"./ExperimentPlate.png": 651,
	"./ExperimentPlate_Disabled.png": 80804,
	"./ExperimentPlate_Dispensed.png": 55157,
	"./ExperimentPlate_Expired.png": 40557,
	"./ExperimentPlate_Expired_Imaged.png": 73179,
	"./ExperimentPlate_Imaged.png": 74021,
	"./ExperimentPlate_Imaged_NotViewed.png": 79059,
	"./Experiment_Designed.png": 75149,
	"./Experiment_Dispensed.png": 27689,
	"./Experiment_Expired.png": 42017,
	"./Experiment_Expired_Hits_16.png": 35896,
	"./Experiment_Imaged.png": 94217,
	"./Experiment_ImagedNotViewed_Hits_16.png": 78487,
	"./Experiment_ImagedViewed_Hits_16.png": 88920,
	"./Experiment_Imaged_NotViewed.png": 57423,
	"./Export.png": 4468,
	"./ExportPOI.png": 61602,
	"./Folder.png": 77050,
	"./Folder_Hits_16.png": 36995,
	"./Folder_opened.png": 21308,
	"./Folder_opened_Hits_16.png": 26805,
	"./FragmentScreen.png": 78466,
	"./HarvestedExperimentNodeIcon.png": 35562,
	"./Histogram.png": 84822,
	"./HitsReport.png": 58606,
	"./ImageManagementTask.png": 15129,
	"./ImagerQuota.png": 56973,
	"./Images.png": 29180,
	"./Images_opened.png": 41910,
	"./Ingredients.png": 63384,
	"./Integerated_Active.png": 44009,
	"./Integerated_Device.png": 36649,
	"./Integerated_Idel.png": 67,
	"./Integerated_Marco.png": 7873,
	"./Integerated_Offline.png": 37698,
	"./Integerated_PrintBarcode.png": 20416,
	"./Integrated_Device_NewUI.png": 81445,
	"./Integrated_Marco_NewUI.png": 76123,
	"./Integrated_PrintBarcode_NewUI.png": 33704,
	"./New.png": 96646,
	"./Next.png": 68369,
	"./OpenTab.png": 76701,
	"./Open_Tab_Gray.png": 96306,
	"./POI.png": 47020,
	"./Paste.png": 19477,
	"./Plate_Expired_Hits_16.png": 71203,
	"./Plate_ImagedNotViewed_Hits_16.png": 86376,
	"./Plate_ImagedViewed_Hits_16.png": 66437,
	"./Pointer.png": 75303,
	"./Previous.png": 78237,
	"./Project.png": 175,
	"./Project_Context.png": 6931,
	"./Project_Hits_16.png": 89582,
	"./Project_opened.png": 45415,
	"./Project_opened_Hits_16.png": 4742,
	"./Projects.png": 8804,
	"./ProjectsOld.png": 14321,
	"./Projects_opened.png": 43358,
	"./Protein-Formulation.png": 36342,
	"./Protein.png": 64125,
	"./ProteinFormulation.png": 99513,
	"./ROI.png": 20042,
	"./Refresh.png": 65309,
	"./Remove.png": 85426,
	"./Rename.png": 67092,
	"./Report.png": 18456,
	"./RockMaker_News.png": 54807,
	"./Ruler.png": 42680,
	"./Scheduling.png": 65896,
	"./Screen.png": 10626,
	"./ScreenLot.png": 20409,
	"./Screen_Dispensed.png": 69008,
	"./Screens.png": 98131,
	"./Screens_opened.png": 61667,
	"./Scribble.png": 7162,
	"./SearchAnalysis.png": 78712,
	"./Seed.png": 77973,
	"./Seed14x9.png": 15503,
	"./Setup.png": 93299,
	"./SynchrotronTrip.png": 60466,
	"./SynchrotronTrips.png": 26147,
	"./TextSearch.png": 83031,
	"./TreeControl/BreadCrumbHistoryIcon.png": 22896,
	"./TreeControl/Experiment.png": 6001,
	"./TreeControl/Folder.png": 74640,
	"./TreeControl/FragmentScreen.png": 48124,
	"./TreeControl/Project.png": 66541,
	"./TreeControl/Projects.png": 36290,
	"./TreeControl/Protein.png": 38439,
	"./TreeControl/Screen.png": 96420,
	"./TreeControl/Screens.png": 78581,
	"./Users.png": 77220,
	"./Wizard.png": 74739,
	"./ZoomIn.png": 85814,
	"./ZoomOut.png": 21087,
	"./exp-hits-16.png": 66824,
	"./expired-experiments-16.png": 30962,
	"./favorite_Folder.png": 48615,
	"./favorite_FolderHits.png": 23249,
	"./favorite_FolderXtals.png": 9613,
	"./favorite_Project.png": 99996,
	"./favorite_ProjectHits.png": 91954,
	"./favorite_ProjectXtals.png": 21372,
	"./plate-hits-16.png": 11405,
	"./plate-viewed-expired-hits-16.png": 74898,
	"./recent_CrystalHarvested.png": 81490,
	"./recent_Designed.png": 40589,
	"./recent_Dispensed.png": 35113,
	"./recent_Expired.png": 5217,
	"./recent_Folder.png": 63344,
	"./recent_Hits.png": 95158,
	"./recent_Imaged.png": 86633,
	"./recent_NewDesigned.png": 33017,
	"./recent_Project.png": 80813,
	"./singleDropBlank.png": 7319
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23965;